import { NSARouterMakerResult } from "namirasoft-account-react";
import { BudgetInputRow, BudgetRow } from "namirasoft-inference";
import { NSBox, NSBoxString, NSBoxDouble, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface BudgetEditPageProps extends NSARouterMakerResult, InferenceRouterProps
{
    isEdit: boolean;
}

export default class BudgetEditPage extends Component<BudgetEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxDouble_CostLimitPerMonth = createRef<NSBoxDouble>();
    NSBoxDouble_CostLimitPerWeek = createRef<NSBoxDouble>();
    NSBoxDouble_CostLimitPerDay = createRef<NSBoxDouble>();
    NSBoxDouble_CostLimitPerChat = createRef<NSBoxDouble>();
    NSBoxDouble_CostLimitPerRun = createRef<NSBoxDouble>();
    NSBoxString_Description = createRef<NSBoxString>();

    override render()
    {
        return (
            <InferenceLayout<BudgetRow, BudgetInputRow>
                {...this.props}
                action={{ description: this.props.isEdit ? InferenceInfo.budget.edit : InferenceInfo.budget.create }}
                pages={{
                    entity: InferenceEntities.budget(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): BudgetInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let cost_limit_per_month = this.NSBoxDouble_CostLimitPerMonth.current?.getValue() ?? null;
                                        let cost_limit_per_week = this.NSBoxDouble_CostLimitPerWeek.current?.getValue() ?? null;
                                        let cost_limit_per_day = this.NSBoxDouble_CostLimitPerDay.current?.getValue() ?? null;
                                        let cost_limit_per_chat = this.NSBoxDouble_CostLimitPerChat.current?.getValue() ?? null;
                                        let cost_limit_per_run = this.NSBoxDouble_CostLimitPerRun.current?.getValue() ?? null;
                                        let description = this.NSBoxString_Description.current?.getValue() ?? null;
                                        return {
                                            workspace_id: null,
                                            name,
                                            cost_limit_per_month,
                                            cost_limit_per_week,
                                            cost_limit_per_day,
                                            cost_limit_per_chat,
                                            cost_limit_per_run,
                                            description,
                                            budget_category: [],
                                            budget_field: [],
                                            budget_tag: [],
                                        };
                                    },
                                    setRow: (row: BudgetRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxDouble_CostLimitPerMonth.current?.setValue(row.cost_limit_per_month);
                                        this.NSBoxDouble_CostLimitPerWeek.current?.setValue(row.cost_limit_per_week);
                                        this.NSBoxDouble_CostLimitPerDay.current?.setValue(row.cost_limit_per_day);
                                        this.NSBoxDouble_CostLimitPerChat.current?.setValue(row.cost_limit_per_chat);
                                        this.NSBoxDouble_CostLimitPerRun.current?.setValue(row.cost_limit_per_run);
                                        this.NSBoxString_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-name" }}
                    />
                    <NSBoxDouble
                        ref={this.NSBoxDouble_CostLimitPerMonth}
                        title="Cost Limit Per Month (USD)"
                        required={false}
                        min={0}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-cost-limit-per-month" }}
                    />
                    <NSBoxDouble
                        ref={this.NSBoxDouble_CostLimitPerWeek}
                        title="Cost Limit Per Week (USD)"
                        required={false}
                        min={0}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-cost-limit-per-week" }}
                    />
                    <NSBoxDouble
                        ref={this.NSBoxDouble_CostLimitPerDay}
                        title="Cost Limit Per Day (USD)"
                        required={false}
                        min={0}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-cost-limit-per-day" }}
                    />
                    <NSBoxDouble
                        ref={this.NSBoxDouble_CostLimitPerChat}
                        title="Cost Limit Per Chat (USD)"
                        required={false}
                        min={0}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-cost-limit-per-chat" }}
                    />
                    <NSBoxDouble
                        ref={this.NSBoxDouble_CostLimitPerRun}
                        title="Cost Limit Per Run (USD)"
                        required={false}
                        min={0}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-cost-limit-per-run" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/budget/#field-description" }}
                    />
                </NSColumn>
            </InferenceLayout>
        );
    }
}